/**
 * 환불 정책 중앙 관리 데이터
 * 모든 환불 정책 관련 정보를 한 곳에서 관리합니다.
 */

export interface RefundPolicyTier {
  id: string;
  title: string;
  condition: string;
  refundPercentage: number;
  description: string;
  colorScheme: {
    bg: string;
    border: string;
    icon: string;
    text: string;
  };
}

export const refundPolicyTiers: RefundPolicyTier[] = [
  {
    id: 'full',
    title: '출발 4일 전까지',
    condition: '출발 4일 전까지 취소',
    refundPercentage: 100,
    description: '100% 환불 가능 (수수료 없음)',
    colorScheme: {
      bg: 'bg-green-50',
      border: 'border-green-200',
      icon: 'text-green-600',
      text: 'text-green-900'
    }
  },
  {
    id: 'partial',
    title: '출발 3일 전 ~ 1일 전 오전',
    condition: '출발 3일 전 ~ 1일 전 오전 12시 이전 취소',
    refundPercentage: 70,
    description: '70% 환불 가능 (30% 수수료)',
    colorScheme: {
      bg: 'bg-yellow-50',
      border: 'border-yellow-200',
      icon: 'text-yellow-600',
      text: 'text-yellow-900'
    }
  },
  {
    id: 'none',
    title: '출발 1일 전 오후 ~ 당일',
    condition: '출발 1일 전 오후 12시 이후 ~ 당일 취소',
    refundPercentage: 0,
    description: '환불 불가',
    colorScheme: {
      bg: 'bg-red-50',
      border: 'border-red-200',
      icon: 'text-red-600',
      text: 'text-red-900'
    }
  }
];

export const specialRefundCases = {
  weather: {
    title: '날씨 및 천재지변',
    description: '날씨나 천재지변으로 인한 취소 시 100% 환불',
    note: '홀씨에서 취소 처리하기 전 자의적 판단으로 미리 취소한 건은 일반 취소 규정이 적용됩니다.'
  },
  minimumParticipants: {
    title: '최소 인원 미달',
    description: '최소 출발 인원(15명) 미달 시 100% 환불',
    note: '출발 5일 전부터 안내드리며, 전액 환불 또는 다른 일정으로 변경 가능합니다.'
  },
  companyCancel: {
    title: '여행사 취소',
    description: '모객 부족 및 천재지변, 현지사정에 의한 여행사 취소 시 100% 환불',
    note: '출발 24시간 전까지 취소 통보 시 전액 환불됩니다.'
  }
};

export const refundProcessInfo = {
  method: '결제 수단으로 환불',
  timeline: '취소 접수 후 영업일 기준 3-5일 이내',
  contact: {
    phone: '010-3741-2556',
    email: 'support@wholsee.kr',
    hours: '평일 09:00 - 18:00'
  }
};

// FAQ 데이터에서 사용할 수 있는 포맷된 텍스트
export const refundPolicyText = `출발 4일 전까지: 100% 환불
출발 3일 ~ 1일 전 오전 (오전 12시 이전): 70% 환불
출발 1일 전 오후 (오후 12시 이후): 환불 불가
출발 당일: 환불 불가

날씨나 천재지변으로 인한 취소 시에는 100% 환불해 드립니다.`;

// ProductDetail 페이지용 간단한 버전
export const refundPolicySummary = refundPolicyTiers.map(tier => ({
  percentage: tier.refundPercentage,
  condition: tier.condition,
  description: tier.description
}));